module.exports = __webpack_public_path__ + "static/img/img_default.198e72a2.png";